// 사용 가이드 주제 목록 + 직책별로 보이는 주제 — GuideScreen/상단 바/⚙️ 메뉴가 같은 기준을 쓰게 한곳에.
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRoles } from '@/composables/useRoles'

// 단계: title / body(문장 배열) / mock(실제 화면 모양을 흉내 낸 작은 그림, 선택) / tip(선택)
export const GUIDES = {
    field: {
        icon: '🏞️',
        title: '밭 관리하기 · 농부일지',
        summary: '지인을 짧카로 심고 농부일지를 채워 씨앗 → 새싹 → 떡잎으로 키워요.',
        steps: [
            {
                title: '밭 관리하기는 이런 곳이에요',
                body: [
                    '내가 아는 지인을 "짧카"로 밭에 심고, 농부일지를 채워 가며 키우는 곳이에요.',
                    '농부일지를 채울수록 🌰 씨앗 → 🌿 새싹 → 🍀 떡잎으로 자라요.',
                ],
                tip: '반마다 떡잎 5개를 유지하는 게 목표예요.',
            },
            {
                title: '씨앗을 심어요 (짧카 작성)',
                body: ['홈에서 "🏞️ 밭 관리하기"를 열고, 오른쪽 위 "🌱 씨앗 심기"를 눌러요.', '지인 이름·나이·성별·번호 등을 적고 "제출하기 📨"를 눌러요.'],
                mock: [
                    { t: '밭 관리하기', kind: 'head', btn: ['🌱 씨앗 심기'] },
                    { t: '이름 · 나이 · 성별 · 번호 · 학교/전공 · 환경 · 사는 곳 …' },
                    { t: '제출하기 📨', kind: 'wide' },
                ],
                tip: '재가 없이 바로 "나의 밭"에 올라가요.',
            },
            {
                title: '농부일지를 열어요',
                body: ['아래 "나의 밭" 탭에서 짧카 카드를 누르면 농부일지가 열려요.', '위쪽 탭으로 1·2·3단계를 오가며 써요.'],
                mock: [
                    { t: '🌱 홍길동님의 농부일지', kind: 'head' },
                    { t: '🌰 1단계   🌿 2단계   🍀 3단계', kind: 'hl' },
                ],
            },
            {
                title: '1단계와 2단계를 채워요',
                body: ['두 단계를 다 채워야 떡잎 재가를 받을 수 있어요. 다 쓰면 "저장하기 📨"를 눌러요.'],
                list: [
                    '🌰 1단계: 성별, 나이, 관계, 연락처, 거주지',
                    '🌿 2단계: 학교/학과, 성격, 취미/관심사, 이성친구 유무, 가족관계, 1년 환경',
                ],
                tip: '길게 써도 괜찮아요. 칸마다 500~1000자까지 저장돼요.',
            },
            {
                title: '떡잎 재가를 받아요',
                body: [
                    '1·2단계를 다 채워 저장하면 자동으로 "⏳ 떡잎 재가 대기"가 돼요.',
                    '재가되면 🍀 떡잎이 돼요. 반려되면 고쳐서 다시 저장하면 다시 올라가요.',
                ],
                mock: [
                    { t: '2단계까지 다 썼어요! 반장님이 재가하면 떡잎이 돼요 🍀', kind: 'bot' },
                    { t: '⏳ 떡잎 재가 대기', kind: 'hl' },
                ],
                tip: '🍀 3단계(되고 싶은 모습·최근 고민·가족분위기·인간관계)는 떡잎이 된 뒤에 이어서 채워요.',
            },
        ],
    },
    hapdang: {
        practice: 'hapdangPractice',  // 연습 화면에서 직접 눌러보는 튜토리얼
        icon: '🤝',
        title: '합당한자',
        summary: '우리 지역 shed 오프찾을 이관받고 티엠해요. (10/8부터)',
        steps: [
            {
                title: '합당한자는 이런 곳이에요',
                body: [
                    '10/8부터 shed에서 넘어온 사람을 우리 지역이 이관받고 티엠하는 곳이에요. 홈의 "🤝 합당한자"로 들어가요.',
                    '10/8 전에 이관받은 사람은 지금처럼 선한 양치기·질적 찾기에서 이어서 해요.',
                ],
            },
            {
                title: '이관받기',
                body: [
                    '"📋 ddochi 미등록"에 shed에서 넘어온 사람이 보여요. "이관받기"를 누르면 확인창이 떠요.',
                    '연락처·지역·환경·반응·유입자·찾기장소·예약 티엠을 보고 "응!"을 누르면 우리 명단으로 들어와요.',
                ],
                mock: [
                    { t: '[4지역] 홍길동 (22세)', kind: 'head' },
                    { t: '유입자 김재민 · 찾기장소 강남역 · 예약 티엠 10/08 20:45' },
                    { t: '이관받을까요?', kind: 'hl', btn: ['응!', '아니'] },
                ],
                tip: '받지 않을 사람은 "반려하기". 반려된 건은 반려 목록에서 "회생하기"로 되살릴 수 있어요.',
            },
            {
                title: '선문자 보내고 전화 걸기',
                body: [
                    '처음엔 카드의 "💌 선문자"로 첫 문자를 보내요. 보내고 나면 그 자리에 "📞 전화걸기"가 생겨요.',
                    '"📞 전화걸기"를 누르면 🟢 통화중이 되고, 다른 사람에게는 🔴 통화중(내 이름)으로 보여서 겹쳐 걸지 않아요. "📝 스크립트"로 멘트를 봐요.',
                ],
                mock: [
                    { t: '홍길동 (22세)', btn: ['💌 선문자'] },
                    { t: '홍길동 (22세)', btn: ['📞 전화걸기'] },
                    { t: '🟢 통화중', kind: 'ok', btn: ['📝 스크립트', '💌 선문자'] },
                ],
            },
            {
                title: '통화 결과를 남겨요',
                body: ['통화가 끝나면 결과 버튼을 눌러요. 예약은 다음 통화 날짜를, 비합·거절·무효는 사유를 골라요.', '다 끝나면 "끊기"를 눌러요.'],
                mock: [
                    { t: '', btn: ['안받음', '예약', '만남픽스'] },
                    { t: '', btn: ['비합', '거절', '무효'] },
                    { t: '끊기', kind: 'wide' },
                ],
                tip: '예약을 잡으면 텔레그램 예약 타임테이블에 올라가고, 결과가 들어오면 ⭕로 바뀌어요.',
            },
            {
                title: '만남픽스 다음엔 합재양',
                body: [
                    '만남픽스를 누르면 "📝 합재양 작성 필요"로 올라가요. "합재양 작성하기"로 합재양을 써요.',
                    '합재양을 내면 인도자가 정해져요.',
                ],
                list: [
                    '🌏 전체 공개였던 건: 티엠자가 인도자',
                    '1지역·5지역: 룰렛을 돌려요 (티엠자 60% · 유입자 40%)',
                    '그 외 지역: 룰렛 없이 유입자가 인도자',
                ],
                tip: '인도자가 비어 있는 건은 종료된 건에서 "🎰 재가챠"로 다시 정할 수 있어요.',
            },
            {
                title: '탭으로 나눠 봐요',
                body: ['위쪽 탭으로 볼 범위를 골라요.'],
                list: [
                    '우리 지역: 우리 지역 건',
                    'N지역: 그 지역 건만',
                    '🌏 전체 공개: 다른 지역도 같이 돌릴 수 있게 열린 건',
                ],
                mock: [{ t: '', btn: ['우리 지역', '4지역', '🌏 전체 공개'] }],
            },
            {
                title: '🌏 전체 공개 건은 누구나 돌려요',
                body: [
                    'shed 신청일부터 4일이 지났거나 티엠을 4번 이상 건 건은 🌏 전체 공개 탭에 모여요.',
                    '카드에 이유(🌏 5일 지남 / 🌏 티엠 4회)가 붙어 있고, 다른 지역이 전화해도 돼요.',
                ],
                mock: [{ t: '홍길동 (22세) · 5지역', btn: ['🌏 5일 지남'] }],
            },
        ],
    },
    legacyFind: {
        icon: '🐑',
        title: '선한 양치기 · 질적 찾기',
        summary: '10/8 전에 이관받은 진행 중인 건을 마무리하는 화면이에요.',
        steps: [
            {
                title: '어떤 화면이에요?',
                body: [
                    '10/8 전에 이관받은 사람을 끝까지 티엠하는 화면이에요. 그 뒤에 받는 사람은 모두 🤝 합당한자에서 해요.',
                    '홈에서 1·3·5지역은 "🐑 선한 양치기", 2·4·6지역은 "🌿 질적 찾기"로 들어가요.',
                ],
                tip: '새로 이관받기·반려된 건 회생하기는 여기서 안 돼요. 합당한자에서 해요.',
            },
            {
                title: '진행 중인 건을 돌려요',
                body: ['"🗂️ ddochi TM 관리"에 진행 중인 건이 보여요. 쓰는 법은 합당한자와 똑같아요.'],
                list: [
                    '📞 전화걸기 → 🟢 통화중 (다른 사람에겐 🔴 통화중으로 보여요)',
                    '결과: 안받음 · 예약 · 만남픽스 · 비합 · 거절 · 무효',
                    '📝 스크립트, 💌 선문자, 끝나면 "끊기"',
                ],
                mock: [
                    { t: '🗂️ ddochi TM 관리 (12명)', kind: 'head', btn: ['진행'] },
                    { t: '홍길동 (22세)', btn: ['📞 전화걸기'] },
                ],
            },
            {
                title: '만남픽스 다음엔 합재양',
                body: ['만남픽스한 건은 "📝 합재양 작성 필요"에 올라가요. "합재양 작성하기"로 써요.'],
                list: ['1지역·5지역: 룰렛으로 인도자 (티엠자 60% · 유입자 40%)', '그 외 지역: 유입자가 인도자'],
            },
            {
                title: '끝난 건 보기',
                body: [
                    '"🗂️ ddochi TM 관리" 오른쪽 "진행" 버튼을 누르면 "종료"로 바뀌면서 끝난 건이 보여요.',
                    '아래 "✅ 종료된 건"에서는 합재양까지 간 건과 인도자를 볼 수 있어요.',
                ],
                tip: '인도자가 비어 있으면 "🎰 재가챠"로 정해요. 합재양을 잘못 냈으면 "합재양 제출 취소하기"로 되돌려요.',
            },
            {
                title: '사람 찾기',
                body: ['위쪽 "🔍 검색"에 이름, 전화번호, 유입자 이름을 넣으면 진행 중·종료된 건에서 찾아줘요.'],
            },
        ],
    },
    tgcmd: {
        icon: '🛡️',
        title: '텔레그램에서 교사·결과 입력',
        summary: '매칭 현황판 방에서 명령어로 교사와 매칭 결과를 바로 넣어요.',
        steps: [
            {
                title: '어디서 쓰나요',
                body: ['우리 지역 매칭 현황판이 올라오는 텔레그램 방에서 써요.', '현황판 맨 아래 "📝 명령어 안내"를 누르면 언제든 펼쳐 볼 수 있어요.'],
                mock: [{ t: '📝 명령어 안내 (눌러서 펼치기)', kind: 'hl' }],
            },
            {
                title: '교사 입력',
                body: ['"/t 섭외자 교사" 형태로 보내요.'],
                mock: [
                    { t: '/t 홍길동 김철수', kind: 'me' },
                    { t: '✅ 홍길동 — 교사 [김철수] 입력 완료!', kind: 'bot' },
                ],
                list: ['타지역 교사: /t 홍길동 김철수(타지역)', '교사 해제: /t 홍길동 -'],
            },
            {
                title: '결과 입력을 시작해요',
                body: ['"/r 섭외자"를 보내면 봇이 결과 버튼을 보내요.'],
                mock: [
                    { t: '/r 홍길동', kind: 'me' },
                    { t: '🛡️ 홍길동 매칭 결과 (10/08 19:00)', kind: 'bot' },
                    { t: '', btn: ['취소', '밀림', '비합'] },
                    { t: '', btn: ['탈락', '2차만남', '상담연결'] },
                ],
            },
            {
                title: '사유를 골라요',
                body: ['취소·비합·탈락을 누르면 같은 메시지가 사유 버튼으로 바뀌어요. 고르면 바로 저장돼요.', '상담연결은 누르자마자 저장돼요.'],
                mock: [
                    { t: '비합 사유를 골라줘', kind: 'bot' },
                    { t: '', btn: ['환경비합', '인성비합'] },
                    { t: '', btn: ['정신질환', '건강비합'] },
                    { t: '✅ → 인성비합 입력 완료', kind: 'ok' },
                ],
            },
            {
                title: '밀림·2차만남은 날짜를 답장으로',
                body: ['밀림이나 2차만남을 누르면 날짜를 물어봐요.', '그 메시지에 "답장"으로 날짜와 시간을 보내요. 아직 모르면 "날짜 미정"을 눌러요.'],
                mock: [
                    { t: '밀림 — 다음 만남 날짜를 이 메시지에 답장으로 보내줘', kind: 'bot' },
                    { t: '↩️ 10/12 19:00', kind: 'me' },
                    { t: '✅ → 밀림 (10/12 19:00) 입력 완료', kind: 'ok' },
                ],
                tip: '꼭 "답장"으로 보내야 해요. 그냥 보내면 봇이 어느 건인지 몰라요.',
            },
            {
                title: '같은 이름이 여럿일 때',
                body: ['봇이 날짜·인도자와 함께 목록을 보내요. 그중 맞는 건의 명령을 쓰면 돼요.'],
                mock: [
                    { t: '⚠️ [홍길동]이(가) 2명이야. 아래에서 골라줘', kind: 'bot' },
                    { t: '· 10/08 19:00 인도자 나유진 → /r_36017851' },
                    { t: '· 10/09 18:00 인도자 장은혜 → /r_ff00ff00' },
                ],
                tip: '입력하면 매칭 현황판이 바로 갱신돼요. 잘못 넣었으면 앱의 "매칭 절대 지켜!"에서 고쳐요.',
            },
        ],
    },
    telegram: {
        // 방 연결은 관리자 화면에서 하는 일이라 전도팀장 이상만(2026-10-09)
        canSee: ({ isAdmin, hasRegionRole, role }) => isAdmin || hasRegionRole || /지역장|전도팀장/.test(role || ''),
        icon: '💬',
        title: '텔레그램 방 연결하기',
        summary: '일일보고·현황판이 우리 지역 텔레그램 방에 자동으로 올라오게 연결해요.',
        steps: [
            {
                title: '시작 전에 준비할 것',
                body: [
                    '연결하면 일일보고, 찾기·매칭 현황판, 예약 타임테이블 같은 판이 그 방에 정각마다 자동으로 올라와요.',
                    '두 가지가 필요해요.',
                ],
                list: ['또치 관리자 비밀번호', '연결할 텔레그램 단톡방 (멤버를 초대할 수 있어야 해요)'],
            },
            {
                title: '봇을 방에 초대해요',
                body: ['연결할 텔레그램 단톡방에서 방 이름을 눌러 멤버 추가로 들어가요.', '아래 봇을 검색해서 초대해요.'],
                mock: 'bot',
                tip: '봇이 방에 없으면 연결 명령어를 보내도 아무 일도 안 일어나요.',
            },
            {
                title: '관리자 화면을 열어요',
                body: ['또치 앱 오른쪽 위 ⚙️를 눌러요.', '"👑 사명의 길 (관리자)"를 누르고 관리자 비밀번호를 넣어요.'],
                mock: 'admin',
            },
            {
                title: '텔레그램 연결을 열고 지역을 골라요',
                body: ['관리자 화면에서 "💬 텔레그램 연결"을 눌러요.', '위쪽 탭에서 연결할 지역을 골라요.'],
                mock: 'tabs',
                tip: '135 연합·246 연합·수지역 탭은 연합/전체 방용이에요.',
            },
            {
                title: '판을 고르고 "연결"을 눌러요',
                body: ['그 방에 올릴 판(예: 매칭현황판) 오른쪽의 "연결"을 눌러요.', '명령어가 나오면 📋 복사를 눌러요.'],
                mock: 'pair',
            },
            {
                title: '방에 명령어를 붙여넣어요',
                body: ['복사한 명령어를 그 텔레그램 방에 그대로 보내요.', '10분 안에, 한 번만 쓸 수 있어요.'],
                mock: 'chat',
                tip: '10분이 지나면 "⏰ 코드 만료됨"이 떠요. 다시 "연결"을 누르면 새 명령어가 나와요.',
            },
            {
                title: '연결됐는지 확인해요',
                body: ['앱에 "✅ 연결됨!"이 뜨고, 그 판 옆에 방 이름이 나와요.', '현황판·일일보고는 첫 판이, 다른 방(기도문·일정 등)은 환영 메시지가 바로 올라와요.'],
                mock: 'done',
            },
            {
                title: '옮기거나 끄고 싶을 때',
                body: [],
                list: [
                    '다른 방으로 옮기기: 🔄 재연결 → 새 방에 명령어 붙여넣기',
                    '연결 끊기: 해제',
                    '정각 발송만 잠깐 멈추기: 같은 탭 위쪽 "⏰ 발송 잡 ON/OFF"에서 끄기',
                ],
                tip: '안 될 때는 ① 봇이 방에 있는지 ② 명령어를 고치지 않았는지 ③ 10분이 지나지 않았는지 확인해 주세요.',
            },
        ],
    },
}


// canSee가 없는 주제는 모두에게 보임
export function useVisibleGuides() {
    const auth = useAuthStore()
    const { hasRegionRole } = useRoles()
    return computed(() => {
        const who = { isAdmin: auth.isAdmin, hasRegionRole: hasRegionRole.value, role: auth.currentUserRole }
        return Object.fromEntries(Object.entries(GUIDES).filter(([, g]) => !g.canSee || g.canSee(who)))
    })
}
